import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  Button,
  Box,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import CloseIcon from "@mui/icons-material/Close";
import { BarChart } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

function Dialog_stock({ abrirDialog, onClose, datosGrafico }) {
  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  // PARA SACAR LA LEYENDA
  const customize = {
    legend: { hidden: true },
  };

  const chartSetting = {
    yAxis: [
      {
        label: "Cantidad de stock",
      },
    ],
    width: 650,
    height: 300,
    sx: {
      [`.${axisClasses.left} .${axisClasses.label}`]: {
        transform: "translate(-25px, 0)",
      },
    },
  };

  if (
    !datosGrafico ||
    !datosGrafico.dataset ||
    datosGrafico.dataset.length === 0
  ) {
    return null;
  }

  return (
    <Dialog fullScreen open={abrirDialog} onClose={handleClose}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Stock actual de insumos
          </Typography>
          <Button autoFocus color="inherit" onClick={handleClose}>
            Cerrar
          </Button>
        </Toolbar>
      </AppBar>
      <DialogContent>
        {/* LEYENDA */}
        <Box
          sx={{
            backgroundColor: "#DEDEDE",
            border: "1px solid black",
            borderRadius: 2,
            padding: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(2, 1fr)",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: `repeat(${Math.min(datosGrafico.sucursales.length, 6)}, 1fr)`,
              xl: `repeat(${Math.min(datosGrafico.sucursales.length, 8)}, 1fr)`,
            },
            columnGap: 2,
            rowGap: 1,
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              gridColumn: {
                xs: "span 2",
                sm: "span 2",
                md: "span 3",
                lg: `span ${Math.min(datosGrafico.sucursales.length, 6)}`,
                xl: `span ${Math.min(datosGrafico.sucursales.length, 8)}`,
              },
              color: "black",
            }}
          >
            Leyenda del gráfico
          </Typography>

          {datosGrafico.sucursales.map((sucursal, index) => (
            <Box
              key={sucursal}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Box
                sx={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  backgroundColor: datosGrafico.colores[index],
                  marginRight: 1,
                  flexShrink: 0,
                  border: "1px solid #000",
                }}
              />
              <Typography variant="body2">{sucursal}</Typography>
            </Box>
          ))}
        </Box>
        {/* GRAFICO */}
        <Paper elevation={10} sx={{ mt: 3 }}>
          <Typography
            align="center"
            sx={{
              fontWeight: "bold",
              fontSize: 20,
              textAlign: "center",
              mt: 1,
            }}
          >
            Stock actual de insumos
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              height: 300,
              width: "100%",
              p: 2,
            }}
          >
            <BarChart
              dataset={datosGrafico.dataset}
              xAxis={[{ dataKey: "articulo", scaleType: "band" }]}
              series={datosGrafico.sucursales.map((sucursal, index) => ({
                dataKey: sucursal,
                label: sucursal,
                valueFormatter: (v) => `${v ?? 0} unidades`,
                color: datosGrafico.colores[index],
              }))}
              layout="vertical"
              // width={1000}
              {...chartSetting}
              grid={{ vertical: true }}
              {...customize}
            />
          </Box>
        </Paper>
      </DialogContent>
    </Dialog>
  );
}

export default Dialog_stock;
